import { SVGProps } from 'react';
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 25 10" {...props}>
    <path fill="currentColor" d="M2.5 2.044h20v5h-20v-5Z" />
  </svg>
);
export default SvgComponent;
